import { apiFetch } from './api';

export type StatusLaudo = 'Rascunho' | 'Assinado' | 'Cancelado';

export type Laudo = {
  id: string;
  atendimentoId: string;
  autorId: string;
  titulo: string;
  conteudoMarkdown: string;
  status: StatusLaudo;
  crm: string | null;
  criadoEm: string;
  assinadoEm: string | null;
};

export const listLaudos = (params: { atendimentoId?: string; pacienteId?: string; status?: StatusLaudo } = {}) => {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v) q.set(k, String(v));
  return apiFetch<Laudo[]>(`/laudos${q.toString() ? `?${q}` : ''}`);
};

export const getLaudo = (id: string) => apiFetch<Laudo>(`/laudos/${id}`);

export const createLaudo = (data: {
  atendimentoId: string;
  titulo: string;
  conteudoMarkdown: string;
  crm?: string;
}) => apiFetch<Laudo>('/laudos', { method: 'POST', body: JSON.stringify(data) });

export const updateLaudo = (id: string, data: { titulo?: string; conteudoMarkdown?: string }) =>
  apiFetch<void>(`/laudos/${id}`, { method: 'PATCH', body: JSON.stringify(data) });

export const assinarLaudo = (id: string, crm?: string) =>
  apiFetch<void>(`/laudos/${id}/assinar`, { method: 'POST', body: JSON.stringify({ crm }) });

export const cancelarLaudo = (id: string) =>
  apiFetch<void>(`/laudos/${id}`, { method: 'DELETE' });
